import { connect } from 'react-redux';
import { setCurrentTab } from 'store/siteCoordinator/siteCoordinator.actions';
import {
  fetchInitialStart,
  viewPodCastStart,
  fetchPodCastEpisodeStart
} from 'store/podcast/podcast.actions';
import { getGenresStart } from 'store/podcast/podcast.actions';
import {
  getHeartsPodcastStart,
  getHistoryPodcastStart,
  addPlayPodcastStart,
  podcastHeartStart,
  removeFavoritePodcastStart
} from 'store/userHistoryPodcast/userHistoryPodcast.actions';
import { ratingHandleStart } from 'store/podcast/podcast.actions';
import { episodePlayerStart } from 'store/playerPodCast/playerPodCast.actions';
import {
  setPodCastUrl,
  fetchURLPodcastStart,
  setAudioStatus
} from 'store/playerPodCast/playerPodCast.actions';
import { showSnackbarNotification } from 'store/notification/notification.actions';
import {
  setCurrentViewdPodPlaylist,
  queuePodEpisodeId,
  setCurrentPodcastid,
  setPodcastQueue
} from 'store/podcastPlaylist/podcastPlaylist.actions';

const mapStateToProps = (state) => ({
  userState: state.user,
  podcastState: state.podcast,
  playerPodCastState: state.playerPodCast,
  userHistoryPodcastState: state.userhistoryPodcast,
  podcastPlaylistState: state.podcastPlaylist,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchInitialStart: () => dispatch(fetchInitialStart()),
  onGetGenresStart: () => dispatch(getGenresStart()),
  onFetchURLPodcastStart: (podcastURL, episodeURL) =>
    dispatch(fetchURLPodcastStart(podcastURL, episodeURL)),
  onGetHeartsPodcastStart: () => dispatch(getHeartsPodcastStart()),
  onGetHistoryPodcastStart: () => dispatch(getHistoryPodcastStart()),
  onSetPodCastUrl: () => dispatch(setPodCastUrl()),
  onSetAudioStatus: (status) => dispatch(setAudioStatus(status)),
  onAddPlayPodcastStart: (id) => dispatch(addPlayPodcastStart(id)),
  onFavouritePodcast: (id) => dispatch(podcastHeartStart(id)),
  onRemoveFavoritePodcastStart: (id) =>
    dispatch(removeFavoritePodcastStart(id)),
  onEpisodePlayerStart: (podcastid, episodeid) =>
    dispatch(episodePlayerStart(podcastid, episodeid)),
  onRatingHandleStart: (stationid) => dispatch(ratingHandleStart(stationid)),
  onSetCurrentTab: (value) => dispatch(setCurrentTab(value)),
  onSetCurrentViewdPodPlaylist: (podcastId) =>
    dispatch(setCurrentViewdPodPlaylist(podcastId)),
  onViewPodCastStart: (value) => dispatch(viewPodCastStart(value)),
  onFetchPodCastEpisode: (podcastId) =>
    dispatch(fetchPodCastEpisodeStart(podcastId)),
  onQueuePodEpisodeId: (id) => dispatch(queuePodEpisodeId(id)),
  onShowSnackbarNotification: (message) =>
    dispatch(showSnackbarNotification(message)),
  onSetCurrentPodcastid: (podcastid) =>
    dispatch(setCurrentPodcastid(podcastid)),
  onSetPodcastQueue: (podcastid, episodeid) =>
    dispatch(setPodcastQueue(podcastid, episodeid))
});

const container = connect(mapStateToProps, mapDispatchToProps);

export default container;
